import React, { useEffect, useState } from 'react';
import {
  Button,
  Loading,
  OverlayTrigger,
  PopOver,
  Dialog,
  Icon,
} from '@tencent/spaui';
import '../../../../../style/less/modules/state-manage.less';
import { RPCFactory } from '../../../../utils/RequestUtil';
import EditDialog from './editDialog';

const CallSetting = () => {
  const [isLoading, setLoading] = React.useState(false);
  const [entities, setEntities] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [delDialogShow, setDelDialogShow] = useState(false);
  const [editDialogShow, setEditDialogShow] = useState(false);
  const [dialogState, setDialogState] = useState('add');
  const [speechId, setCurSpeechId] = useState(-1);
  const [showTip, setShowTip] = useState(false);
  useEffect(() => {
    getSpeechList();
  }, []);
  useEffect(() => {
    if (refresh) {
      getSpeechList();
    }
  }, [refresh]);
  const getSpeechList = () => {
    setLoading(true);  
    RPCFactory.call.getSpeechList()
    .done((data) => {
      setLoading(false);
      setRefresh(false);
      setEntities(data.entities);
    })
    .fail((code, msg) => {
      setLoading(false);
      setRefresh(false);
      alert(msg);
    });
  }
  const handleAdd = () => {
    setEditDialogShow(true);
    setDialogState('add');
    setCurSpeechId(-1);
  }
  const handleEdit = (speechId) => {
    setDialogState('edit');
    setCurSpeechId(speechId);
    setEditDialogShow(true);
  };
  const handleDelete = (speechId) => {
    setCurSpeechId(speechId);
    setDelDialogShow(true);
  };
  const submitDelete = () => {
    RPCFactory.call.deleteSpeech({ speechId })
    .done((data) => {
      setDelDialogShow(false);
      setRefresh(true);
    })
    .fail((code, msg) => {
      alert(msg);
    });
  };
  const renderSpeechList = () => {
    return (
      <ul className="custom-infolist">
        {entities.map((ele, index) => (
            <li className="item">
              <span className="item-left">{index+1}</span>
              <div className="item-right">
                <div className="content">
                  <p className="tt">
                    {ele.usedScene}
                  </p>
                  <p className="desc">
                    <p style={{ wordBreak: 'break-all' }}>{ele.speechContent}</p>
                  </p>
                </div>
              </div>
              {window.pageProps.originRole !== 'OPERATOR_ROLE_LEADS_OBSERVER'
              && <div className="action" style={{ marginLeft: '15px', marginTop: '15px' }}>
                <a
                  aria-label="编辑"
                  className="editable-icon"
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    handleEdit(ele.speechId);
                  }}
                >
                  <i className="icon icon-pen"></i>
                </a>
                <a
                  aria-label="删除"
                  className="editable-icon"
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    handleDelete(ele.speechId);
                  }}
                >
                  <i className="icon icon-close"></i>
                </a>
              </div>}
            </li>
          ))}
      </ul>
    );
  };
  const editSpeech = entities.filter(item => item.speechId == speechId)[0] || {};
  return (
    <div className="setting-state-manage card">
      <div class="tt-wraper" style={{ display: 'flex', marginBottom: '20px' }}>
        <em class="tt speech" style={{ marginRight: '10px' }}>
          <strong>话术报备</strong>
        </em>
        <em class="tt detail" style={{ fontSize: '12px', lineHeight: '20px' }}>
          <span>请添加日常外呼使用的话术。系统会定期审核外呼话术是否合规，如发现违规情况将影响使用外呼功能。</span>
          <OverlayTrigger
            trigger="hover"
            alignment="right"
            overlay={
              <PopOver>
                <p>审核标准：</p>
                <p>1、报备的话术内是否合规</p>
                <p>2、外呼话术是否和报备话术大致相同</p>
              </PopOver>
            }
          >
            <span style={{ textDecorationLine: 'underline' }}>查看审核标准</span>
            <i className="icon icon-help" style={{ marginRight: 8 }} />
          </OverlayTrigger>
        </em>
      </div>
      <div style={{ display: 'flex' }}>
        <Button
          displayType="primary"
          onClick={handleAdd}
          style={{ marginBottom: '20px' }}
          disabled={window.pageProps.originRole == 'OPERATOR_ROLE_LEADS_OBSERVER'}
          >
          ＋添加话术
        </Button>
        <div style={{ marginLeft: '10px', lineHeight: '30px' }}>
          <Icon name='info-filled' color='#296bef' />
          <span
            style={{ marginLeft: '3px',textDecorationLine: 'underline' }}
            onClick={() => setShowTip(true)}
          >查看话术示例</span>
        </div>
      </div>
      {isLoading ? <Loading /> : renderSpeechList()}
      <EditDialog
        show={editDialogShow}
        setEditDialogShow={setEditDialogShow}
        setRefresh={setRefresh}
        dialogState={dialogState}
        usedScene={editSpeech.usedScene}
        speechContent={editSpeech.speechContent}
        speechId={editSpeech.speechId}
      ></EditDialog>
      <Dialog
        show={delDialogShow}
        type="normal"
        className="spaui-dialog-confirm-normal"
        title='删除话术'
        iconType='tip'  //success, tip, warning, error, remind
        backdrop
        onSubmit={() => submitDelete()}
        onCancel={() => setDelDialogShow(false)}
        onClose={() => setDelDialogShow(false)}
      >
        <div className='mt-16'>
          <p>确定删除此话术？</p>
        </div>
      </Dialog>
      <Dialog
        type='normal'
        className='spaui-dialog-confirm-normal'
        backdrop
        enabledBackdropClose
        show={showTip}
        submitLabel="关闭"
        cancelButton={false}
        onClose={() => setShowTip(false)}
        onSubmit={() => setShowTip(false)}
        onCancel={() => setShowTip(false)}
      >
        <div>
          <div class="title" style={{ textAlign: 'left', fontSize: '16px', fontWeight: '550' }}>话术示例</div>
          <div class="sub-title" style={{ textAlign: 'left', fontSize: '14px', fontWeight: '550', marginTop: '10px' }}>用于卖车场景</div>
          <div class="content" style={{ textAlign: 'left' }}>          
              <p style={{ marginTop: '10px' }}>做简单的需求分析：“早上好！（分时问候）XX4S店。我是销售顾问XXX，您可以叫我小X就可以了。您是想询问XXX车辆的价格是吧?</p>
              <p style={{ marginTop: '10px' }}>使用邀约理由：为了方便您更好的了解这款车，我可以为您预约试乘试驾，并且我们这周刚好有促销活动。</p>
              <p style={{ marginTop: '10px' }}>确定时间：您看是周六上午还是下午来方便？（选择法）您可以随时找我，我叫XXX，如果有任何问题，请随时和我联系。请问您还有什么其他问题吗？谢谢您的来电，X先生/女士，再见！</p>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CallSetting;
